import React from 'react';
import logo from '../assets/logo3f.jpg';

const Header = () => {
  const handleClick = () => {
    // Opción 1: recarga completa del navegador
    window.location.reload();
  };

  return (
    <header className="header">
      <img
        src={logo}
        alt="3F Logo"
        className="header__logo"
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      />
    </header>
  );
};

export default Header;
